import { Button, Card, Form, Message, Table } from '@alifd/next';
import axios from 'axios';
import { history } from 'ice';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const { Item } = Form;

const NoticeRecordBlock = (props) => {
  const message = client.service('message');
  const baEvent = client.service('baEvent');
  const [currentAuthId, setCurrentAuthId] = useState('');
  const [currentUserArr, setCurrentUserArr] = useState([]);
  const [isToggled, setToggled] = useState(false);
  const [baStatus, setBaStatus] = useState(false);

  const [curdataIndex, setcurDataIndex] = useState('createdTime');
  const [curorder, setcurOrder] = useState('desc');

  useEffect(() => {
    client.reAuthenticate().then((data) => {
      console.log('==relogin ok', data.user._id);
      setCurrentAuthId(data.user._id);
    });
  }, []);

  async function funFind() {
    if (isToggled === true) {
      const result = await baEvent.find({
        query: {
          $sort: {
            createdTime: -1,
          },
          userId: currentAuthId,
        },
      });
      return result && result.data ? result.data : [];
    } else {
      const result = await message.find({
        query: {
          $sort: {
            createdTime: -1,
          },
          userId: currentAuthId,
        },
      });
      return result && result.data ? result.data : [];
    }
  }
  async function funCreate(obj) {
    return await message.create(obj);
  }
  async function funUpdate(id, obj) {
    return await message.patch(id, obj);
  }
  async function funRemove(id) {
    return await message.remove(id);
  }

  const serverDataUpdate = (dataIndex, order) => {
    const rdataIndex = dataIndex || curdataIndex;
    const rorder = order || curorder;

    funFind().then((result) => {
      setCurrentUserArr(
        result.sort((a, b) => {
          const result = (
            typeof a[rdataIndex] === 'number'
              ? a[rdataIndex].toString()
              : a[rdataIndex]
          ).localeCompare(
            typeof b[rdataIndex] === 'number'
              ? b[rdataIndex].toString()
              : b[rdataIndex]
          );
          return rorder === 'asc' ? (result > 0 ? 1 : -1) : result > 0 ? -1 : 1;
        })
      );
    });
  };
  const onTableSort = (dataIndex, order) => {
    console.log('==dataIndex:', dataIndex, 'order:', order);
    setcurDataIndex(dataIndex);
    setcurOrder(order);
    serverDataUpdate(dataIndex, order);
  };

  const baEventData = () => {
    client
      .service('userGroupRoute')
      .find({ query: { name: 'BA系統' } })
      .then((res) => {
        // console.log(res.data)
        if (res.data.length > 0) {
          setBaStatus(true);
        } else {
          setBaStatus(false);
        }
      });
  };
  useEffect(() => {
    baEventData();
    serverDataUpdate();
  }, [currentAuthId, isToggled]);

  const toggleTrueFalse = () => setToggled(!isToggled);

  console.log(currentUserArr);
  return (
    <Card free>
      <Card.Content>
        {baStatus === true ? (
          <Button
            type="secondary"
            className={styles.baBtn}
            onClick={toggleTrueFalse}
          >
            {isToggled === true ? '全部訊息' : 'BA通知'}
          </Button>
        ) : (
          ''
        )}

        <Table dataSource={currentUserArr} onSort={onTableSort}>
          <Table.Column
            sortable
            dataIndex="createdTime"
            title="建立時間"
            width={100}
            cell={(_value, index) => {
              return (
                <p>
                  {moment(currentUserArr[index].createdTime).format(
                    'YYYY-MM-DD'
                  )}
                </p>
              );
            }}
          />
          <Table.Column sortable title="標題" dataIndex="title" width={150} />
          <Table.Column
            sortable
            title="內容"
            dataIndex="content"
            width={300}
            cell={(value, _index, record) => {
              return (
                <a
                  onClick={() => {
                    history.push(`${record.redirect}`);
                  }}
                >
                  {value}
                </a>
              );
            }}
          />
        </Table>
      </Card.Content>
    </Card>
  );
};

export default NoticeRecordBlock;
